import React from "react";
import createReactClass from "create-react-class";
import ModalContentBase from "./modal_content_base";

export default createReactClass({
  displayName: "Root",
  getInitialState() {
    return {};
  },
  componentDidMount() {},
  render() {
    var gender = <p />;
    switch (this.props.user.gender) {
      case "male":
        gender = (
          <p>
            <i className="fas fa-male" ariaHidden="true" />&nbsp;男性
          </p>
        );
        break;
      case "female":
        gender = (
          <p>
            <i className="fas fa-female" ariaHidden="true" />&nbsp;女性
          </p>
        );
        break;
      default:
    }

    const previewContent = (
      <div className="flex mb20 cursor-pointer">
        <div
          style={{ width: "2.5em", borderRadius: "50%", overflow: "hidden" }}
        >
          <img style={{ width: "100%" }} src={this.props.user.avatar_thumb} />
        </div>
        <p style={{ lineHeight: "2.5em", margin: "0" }}>
          @{this.props.user.tunagate_id}
        </p>
      </div>
    );

    const modalContent = (
      <div className="pc-flex">
        <div style={{ padding: "1.5em", textAlign: "left", width: "100%" }}>
          <div style={{ width: "100%", overflow: "hidden" }}>
            <img style={{ width: "100%" }} src={this.props.user.avatar_thumb} />
          </div>
        </div>
        <div style={{ padding: "1.5em", textAlign: "left", width: "100%" }}>
          <h2
            className="g-font-weight-300 g-mr-10"
            style={{ fontSize: "28px" }}
          >
            @{this.props.user.tunagate_id}
          </h2>
          <div className="flex">{gender}</div>
          <p
            dangerouslySetInnerHTML={{
              __html:
                this.props.user.introduction &&
                this.props.user.introduction.replace(/\r?\n/g, "<br>"),
            }}
          />
        </div>
      </div>
    );

    return (
      <ModalContentBase
        previewContent={previewContent}
        modalContent={modalContent}
      />
    );
  },
});
